import styled from 'styled-components';
var sizes = {
  xlarge: {
    checkboxWidth: 9 * 5 / 1.6,
    width: 21 * 5 / 2 + 6,
    height: 13 * 5 / 2
  },
  large: {
    checkboxWidth: 9 * 4 / 1.6,
    width: 21 * 4 / 2,
    height: 13 * 4 / 2
  },
  medium: {
    checkboxWidth: 9 * 3 / 1.6,
    width: 21 * 3 / 2,
    height: 13 * 3 / 2
  },
  small: {
    checkboxWidth: 9 * 2 / 1.6,
    width: 21 * 2 / 2,
    height: 13 * 2 / 2
  }
};
export var CheckBoxWrapper = styled.div.withConfig({
  displayName: "partials__CheckBoxWrapper",
  componentId: "sc-1bvyauf-0"
})(["position:relative;"]);
export var CheckBoxLabel = styled.label.withConfig({
  displayName: "partials__CheckBoxLabel",
  componentId: "sc-1bvyauf-1"
})(["position:absolute;top:0;left:0;width:", "px;height:", "px;border-radius:15px;cursor:pointer;background:", ";&:after{display:block;width:", "px;height:", "px;border-radius:50%;box-shadow:1px 1px 3px 1px rgba(0,0,0,0.2);margin:", "px;content:'';background:", ";transition:0.2s;}"], function (_ref) {
  var size = _ref.size;
  return sizes[size].width;
}, function (_ref2) {
  var size = _ref2.size;
  return sizes[size].height;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.ui;
}, function (_ref4) {
  var size = _ref4.size;
  return sizes[size].checkboxWidth;
}, function (_ref5) {
  var size = _ref5.size;
  return sizes[size].checkboxWidth;
}, function (_ref6) {
  var size = _ref6.size;
  return (sizes[size].height - sizes[size].checkboxWidth) / 2;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.terciaryLL;
});
export var CheckBox = styled.input.withConfig({
  displayName: "partials__CheckBox",
  componentId: "sc-1bvyauf-2"
})(["z-index:1;opacity:0;width:", "px;height:", "px;border-radius:15px;&:checked + ", "{background:", ";&:after{display:block;width:", "px;height:", "px;border-radius:50%;margin-left:", "px;content:'';transition:0.2s;}}"], function (_ref8) {
  var size = _ref8.size;
  return sizes[size].width;
}, function (_ref9) {
  var size = _ref9.size;
  return sizes[size].height;
}, CheckBoxLabel, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.positive;
}, function (_ref11) {
  var size = _ref11.size;
  return sizes[size].checkboxWidth;
}, function (_ref12) {
  var size = _ref12.size;
  return sizes[size].checkboxWidth;
}, function (_ref13) {
  var size = _ref13.size;
  return sizes[size].width - sizes[size].checkboxWidth - (sizes[size].height - sizes[size].checkboxWidth) / 2;
});